import Container from "@mui/material/Container";
import { styled } from "@mui/material/styles";

import {
  COLOR_GREYSCALE_BLACK_42,
  COLOR_PRIMARY_BLACK,
  COLOR_WHITE,
} from "~/theme/colors";
import { getFormatMedia } from "~/theme/utils";

import { SEARCH_RESULTS_PAGE_CLASSES } from "./constants";

export const SearchResultsPageContainer = styled(Container)(({ theme }) => {
  const { BREAKPOINT_TABLET, BREAKPOINT_DESKTOP } = getFormatMedia(theme);

  return {
    backgroundColor: COLOR_WHITE,
    paddingBottom: theme.spacing(5),
    [BREAKPOINT_TABLET]: {
      paddingBottom: theme.spacing(13),
    },
    [`& .${SEARCH_RESULTS_PAGE_CLASSES.header}`]: {
      textTransform: "none",
      paddingBottom: theme.spacing(3.5),
      paddingTop: theme.spacing(3),
      [BREAKPOINT_TABLET]: {
        textTransform: "none",
        paddingBottom: theme.spacing(5),
      },
      [BREAKPOINT_DESKTOP]: {
        textTransform: "none",
        paddingBottom: theme.spacing(7),
        paddingTop: theme.spacing(5),
      },
    },
    [`& .${SEARCH_RESULTS_PAGE_CLASSES.tabsWrapper}`]: {
      marginBottom: theme.spacing(2),
      [BREAKPOINT_DESKTOP]: {
        marginBottom: 0,
      },
    },
    [`& .${SEARCH_RESULTS_PAGE_CLASSES.tab}`]: {
      whiteSpace: "normal",
      maxWidth: "none",
      "&:focus": {
        boxShadow: `inset 0 -2px 0 0 ${COLOR_PRIMARY_BLACK}`,
      },
    },
    [`& .${SEARCH_RESULTS_PAGE_CLASSES.content}`]: {
      display: "none",
    },
    [`& .${SEARCH_RESULTS_PAGE_CLASSES.active}`]: {
      display: "block",
    },
    [`& .${SEARCH_RESULTS_PAGE_CLASSES.counter}`]: {
      display: "inline-block",
      color: COLOR_GREYSCALE_BLACK_42,
      marginLeft: theme.spacing(1),
      "&::before": {
        content: "'('",
      },
      "&::after": {
        content: "')'",
      },
    },
  };
});
